<template>
  <div class="about">
    <img src="../../assets/img/aboutBanner.png" alt="" style="margin-bottom: 20px">
    <img src="../../assets/img/aboutUs1.png" alt="">
    <img src="../../assets/img/aboutUs2.png" alt="">
    <img src="../../assets/img/aboutUs3.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style lang="scss" scoped>
.about {
  width: 1920px;
  margin: 0 auto;
  background-color: #F6F6F5;
  img {
    vertical-align: top;
  }
}

</style>
